import styled from "styled-components";

export const StyledFirstWave = styled.svg`
  position: relative;
  top: 15px;
  left: 0;
  width: max(1000px, 100vw);
  height: 110px;
  background-size: 100% 100%;
`;

export const StyledSecondWave = styled.svg`
  position: absolute;
  left: 0;
  width: max(1000px, 100vw);
  height: 150px;
  background-size: 100% 100%;
`;

export const WaveContainer = styled.div`
  width: 100%;
`;
